<template>
    <div id="cliente-cadastro">
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Cadastro de evento" />


                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-agenda @newdata="handleDataEmpresa($event)"></formulario-agenda>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import { get, post } from '@/helpers/api';
    import MaskedInput from 'vue-masked-input';
    import { DONO, GERENTE, CORRETOR } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import FormularioAgenda from './Formulario';
    import Message from '@/helpers/message';
    import TituloPagina from '@/components/common/TituloPagina';

    export default {
        components: {
            MaskedInput,
            FormularioAgenda,
            TituloPagina
        },
        data: () => ({
            formData: {
                agenda_nome: '',
                agenda_data: '',
                agenda_hora: '',
                funcionario_id: '',
                agenda_endereco: '',
                agenda_endereco_latitude: '',
                agenda_endereco_longitude: '',
                agenda_descricao: '',
                agenda_data_fim: '',
                agenda_hora_fim: '',
                notificar_minutos_antes: '',
            },
            usuarioLogadoCargo: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
        }),
        created() {
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            // debugger;
        },
        methods: {
            save() {
                // debugger;
                if (
                        this.formData.agenda_nome == '' ||
                        this.formData.agenda_data == '' ||
                        this.formData.agenda_hora == '' ||
                        // this.formData.funcionario_id == '' ||
                        // this.formData.agenda_endereco == '' ||
                        // this.formData.agenda_endereco_latitude == '' ||
                        // this.formData.agenda_endereco_longitude == '' ||
                        // this.formData.agenda_descricao == '' ||
                        this.formData.agenda_data_fim == '' ||
                        this.formData.agenda_hora_fim== ''){
                        // debugger;
                            Message.messageError('Todos os campos são obrigatórios');
                            return;
                        }

                let self = this;
                post('agenda', {
                    agenda_nome: this.formData.agenda_nome,
                    agenda_data: this.formData.agenda_data,
                    agenda_hora: this.formData.agenda_hora,
                    funcionario_id: this.formData.funcionario_id || Auth.getUserId(),
                    agenda_endereco: this.formData.agenda_endereco,
                    agenda_endereco_latitude: this.formData.agenda_endereco_latitude,
                    agenda_endereco_longitude: this.formData.agenda_endereco_longitude,
                    agenda_descricao: this.formData.agenda_descricao,
                    agenda_data_fim: this.formData.agenda_data_fim,
                    agenda_hora_fim: this.formData.agenda_hora_fim,
                    notificar_minutos_antes: this.formData.notificar_minutos_antes,
                }).then(function (response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/');
                }).catch(function () {
                    Message.messageError('Ocorreu algum erro, tente novamente mais tarde.');
                })
            },
            handleDataEmpresa(e) {
                [
                    this.formData.agenda_nome,
                    this.formData.agenda_data,
                    this.formData.agenda_hora,
                    this.formData.funcionario_id,
                    this.formData.agenda_endereco,
                    this.formData.agenda_endereco_latitude,
                    this.formData.agenda_endereco_longitude,
                    this.formData.agenda_descricao,
                    this.formData.agenda_data_fim,
                    this.formData.agenda_hora_fim,
                    this.formData.notificar_minutos_antes,
                ] = e;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/agenda/Cadastro.vue